
import { ref } from "vue";
import Section from "../../components/Section.vue";
import { mapState } from "vuex";
import WrapComponents from "../../components/WrapComponents.vue";
import WrapFlex from "../../components/WrapFlex.vue";
import { getIdFromSlug } from "../../utils/common";
import Swiper from "../../components/Swiper.vue";
import Tabs from "../../components/DetailPage/Tabs.vue";
import PeopleSwiper from "../../components/DetailPage/PeopleSwiper.vue";
import DetailVideoSection from "../../components/DetailPage/DetailVideoSection.vue";
import Event from "../../components/InteractiveComponents/Event.vue";
import DetailAwardSection from "../../components/DetailPage/DetailAwardSection.vue";
import FalcutySection from "../../components/DetailPage/FalcutySection.vue";
import DetailOverview from "../../components/DetailPage/DetailOverview.vue";
import TopSchool from "../../components/InteractiveComponents/TopSchool.vue";
import {
  SKELETON_6_ITEM,
  SKELETON_5_ITEM,
  SKELETON_4_ITEM,
  SKELETON_3_ITEM,
  SKELETON_2_ITEM,
} from "../../utils/constants";
export default {
  components: {
    DetailOverview,
    Tabs,
    Swiper,
    PeopleSwiper,
    DetailVideoSection,
    DetailAwardSection,
    FalcutySection,
    Event,
    TopSchool,
    Section,
    WrapComponents,
    WrapFlex,
  },
  layout: "root",

  computed: {
    ...mapState("SchoolDetail", [
      "school_detail",
      "school_address",
      "school_infra",
      "school_staffs",
      "school_links",
      // "school_others",
      "school_outstanding",
      "loading",
    ]),
    ...mapState("Event", [
      "schoolEvent",
      "eventLoading",
      "newestEventLoading",
      "newestEventData",
    ]),
  },

  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      activeKey: ref("1"),
      mediaUrl: this.$config.BASE_URL_RESOURCE,
      staffSkeletonItems: [],
      livestream: {
        isLive: false,
        date: "",
        link: "",
      },
      skeletonItems: {
        SKELETON_6_ITEM,
        SKELETON_5_ITEM,
        SKELETON_4_ITEM,
        SKELETON_3_ITEM,
        SKELETON_2_ITEM,
      },
    };
  },

  async mounted() {
    const windowWidth = window.innerWidth;
    this.staffSkeletonItems = this.skeletonItems.SKELETON_6_ITEM;

    if (windowWidth <= 1100) {
      this.staffSkeletonItems = this.skeletonItems.SKELETON_5_ITEM;
    }
    if (windowWidth <= 900) {
      this.staffSkeletonItems = this.skeletonItems.SKELETON_4_ITEM;
    }
    if (windowWidth <= 700) {
      this.staffSkeletonItems = this.skeletonItems.SKELETON_3_ITEM;
    }
    if (windowWidth <= 500) {
      this.staffSkeletonItems = this.skeletonItems.SKELETON_2_ITEM;
    }

    const id = getIdFromSlug(this.$route.params.id);
    if (!id) {
      this.showErrorPage();
      return;
    }
    this.$store.commit("SchoolDetail/SET_LOADING", true);
    this.$store.commit("SchoolDetail/SCHOOL_OUTSTANDING", {});
    if (id) {
      const response = await this.$store.dispatch(
        "SchoolDetail/getSchoolDetail",
        id,
      );
      if (response && Object.keys(response.data).length == 0) {
        this.showErrorPage();
      }
      // await this.getSchedule(id);
      // await this.$store.dispatch("SchoolDetail/getSchoolLinks", id);
      // await this.$store.dispatch("Event/getListEventOfSchool", {
      //   schoolId: id,
      // });

      await this.$store.dispatch("SchoolDetail/getSchoolStaffs", id);
      await this.$store.dispatch("SchoolDetail/getSchoolOutstanding", id);
    }
    this.$store.commit("SchoolDetail/SET_LOADING", false);
  },
  methods: {
    showErrorPage(statusCode = 404, message = "Không tìm thấy trường này") {
      this.$nuxt.error({
        statusCode,
        message,
      });
    },
    async getSchedule(schoolId) {
      const response = await this.$store.dispatch(
        "LiveStream/getListSchedule",
        {
          school_id: schoolId,
        },
      );
      if (response?.data?.data?.code && response?.data?.data?.code == "200") {
        this.scheduleList = response?.data?.data?.data;
        console.log({ data: response?.data?.data?.data });
        if (
          response?.data?.data?.data &&
          response?.data?.data?.data.length > 0
        ) {
          const schedule = response?.data?.data?.data.find(
            (item) => item.status == 1,
          );
          // const schedule = response?.data?.data?.data;
          if (schedule && schedule.status == 1) {
            this.livestream = {
              isLive: true,
              date: `${schedule.stream_register_time} ${schedule.stream_register_date}`,
              link: schedule.link,
            };
          }
          console.log(this.livestream);
        }
      }
    },
  },
};
